import React from "react"
import SlateNode from "../slate-node"

// copied video utils from app/region/blocks/video/utils
const getVideoId = url => {
  return url.match(/(\w|-){11}/)?.[0] || ""
}
const getYoutubeThumbnail = url => {
  return `https://img.youtube.com/vi/${getVideoId(url)}/0.jpg`
}

export default function Video({ node, attributes }) {
  const data = node.data.toJS()

  const { width = 480, alignment = "center" } = data

  const clickHandler = e => {
    e.preventDefault()
    return false
  }

  let margin = "0 auto"
  switch (alignment) {
    case "right":
      margin = "0 0 0 auto"
      break
    case "left":
      margin = "0 auto 0 0"
      break
  }
  return (
    <SlateNode
      node={node}
      className="video-container"
      {...attributes}
      style={{ position: "relative", width: Number(width), margin }}
    >
      <a href={data.href} onClick={clickHandler}>
        <img
          alt="video preview"
          className="object-cover object-center w-full bg-gray-200"
          style={{ aspectRatio: "16/9" }}
          src={data.href ? getYoutubeThumbnail(data.href) : null}
        />
        <div
          style={{
            border: 0,
            borderRadius: "50%",
            height: "34px",
            margin: "auto 0",
            padding: "18px 16px 18px 24px",
            width: "30px",
            backgroundColor: data.accentColor || "#1677be",
            boxSizing: "content-box",
            position: "absolute",
            top: "50%",
            left: "calc(50% - 30px)",
            transform: "translateY(-50%)"
          }}
        >
          <div
            style={{
              borderColor: `transparent transparent transparent ${data.playButtonColor ||
                "#fff"}`,
              borderStyle: "solid",
              borderWidth: "17px 0 17px 30px",
              display: "block",
              fontSize: 0,
              height: 0,
              margin: "0 auto",
              padding: 0,
              width: 0
            }}
          >
            &nbsp;
          </div>
        </div>
      </a>
      {node.data.get("children")}
    </SlateNode>
  )
}
